module.exports = __webpack_public_path__ + "themes/custom/iidb/dist/img/logo.cf9336cc.svg";